<template>
  <div class="staff-list">
    <import-data :isFlag="isImport" @refreshList="getList"> </import-data>
    <div class="page_title">员工列表</div>

    <div style="padding: 20px">
      <div class="container">
        <div class="searchbox">
          <div>账号</div>
          <el-input
            v-model="queryCondition.phone"
            clearable
            size="small"
            @input="searchBtn"
            style="width: 180px; margin: 0 10px"
          />
          <div>姓名</div>
          <el-input
            v-model="queryCondition.recommender_name"
            clearable
            size="small"
            @input="searchBtn"
            style="width: 180px; margin: 0 10px"
          />
          <div>工号</div>
          <el-input
            v-model="queryCondition.recommender_code"
            clearable
            size="small"
            @input="searchBtn"
            style="width: 180px; margin: 0 10px"
          />
          <div>状态</div>
          <el-select
            v-model="queryCondition.recommender_status"
            clearable
            size="small"
            @change="searchBtn"
            style="width: 180px; margin: 0 10px"
          >
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-button @click="searchBtn" size="small" type="primary"
            >查询</el-button
          >
          <el-button @click="resetBtn" size="small">重置</el-button>
          <el-button
            @click="indicatorsBtn"
            size="small"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('506') : false
            "
            type="primary"
            >导入指标</el-button
          >
          <el-button
            @click="addEmployeeBtn"
            size="small"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('503') : false
            "
            type="primary"
            >添加员工</el-button
          >
        </div>

        <div class="staff-list-table">
          <el-table
            v-loading="tableLoading"
            ref="staffListTableRef"
            :data="staffListTable"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            @selection-change="handleSelectionChange"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column type="selection" align="center" width="55">
            </el-table-column>

            <el-table-column
              v-for="item in tableHead"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'distric_info'">
                  <div>{{ scope.row.district_name | text_format }}</div>
                  <div>{{ scope.row.district_code | text_format }}</div>
                  <div>{{ scope.row.district_phone | text_format }}</div>
                </div>

                <div v-if="item.prop == 'area_deput_info'">
                  <div>{{ scope.row.area_deputy_name | text_format }}</div>
                  <div>{{ scope.row.area_deputy_code | text_format }}</div>
                  <div>{{ scope.row.area_deputy_phone | text_format }}</div>
                </div>

                <div v-if="item.prop == 'area_manage_info'">
                  <div>{{ scope.row.area_name | text_format }}</div>
                  <div>{{ scope.row.area_code | text_format }}</div>
                  <div>{{ scope.row.area_phone | text_format }}</div>
                </div>

                <div
                  v-else-if="item.prop == 'recommender_status'"
                  class="recommender-status"
                >
                  <i
                    :style="
                      scope.row[item.prop] == 1
                        ? { backgroundColor: '#1ABC9C' }
                        : { backgroundColor: '#FF0000' }
                    "
                  ></i>
                  {{ scope.row[item.prop] | stateText }}
                </div>

                <div v-else>
                  {{
                    JSON.stringify(scope.row[item.prop]) === "null"
                      ? ""
                      : scope.row[item.prop]
                  }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  v-if="scope.row.recommender_status == 1"
                  @click="startOrEnd(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('502')
                      : false
                  "
                  >停用</el-button
                >
                <el-button
                  type="text"
                  v-else
                  @click="startOrEnd(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('502')
                      : false
                  "
                  >启用</el-button
                >
                <el-button
                  type="text"
                  @click="editEmployee(scope.row)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('503')
                      : false
                  "
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('142')
                      : false
                  "
                  @click="referrerEdit(scope.row.recommender_code)"
                  >推荐人编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="footer-box">
          <div class="batch-editor">
            <div class="checkbox">
              <el-checkbox
                v-model="checked"
                @change="staffListCheckbox"
              ></el-checkbox>
            </div>
            <el-button
              @click="startBtn"
              size="small"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('502') : false
              "
              type="primary"
              >启用</el-button
            >
            <el-button
              @click="endBtn"
              size="small"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('502') : false
              "
              >停用</el-button
            >
          </div>
          <pagination
            v-show="totalNum > 0"
            :total="totalNum"
            :page.sync="pagination.page"
            :limit.sync="pagination.pageNumber"
            @pagination="searchList"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
import Pagination from "@/components/Pagination";
import ImportData from "./ImportData.vue";
import staff from "@/api/staff.js";
export default {
  inject: ["reload"],
  components: {
    Pagination,
    ImportData,
  },
  data() {
    return {
      isImport: false,
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      staffListTable: [],
      queryCondition: {
        phone: null,
        recommender_name: null,
        recommender_code: null,
        recommender_status: null,
      },
      stateOptions: [
        {
          value: 1,
          label: "在职",
        },
        {
          value: 2,
          label: "离职",
        },
      ],
      tableHead: [
        {
          prop: "phone",
          label: "账号",
        },
        {
          prop: "recommender_code",
          label: "员工编号",
        },
        {
          prop: "recommender_name",
          label: "姓名",
        },
        {
          prop: "distric_info",
          label: "区域经理信息",
        },
        {
          prop: "area_deput_info",
          label: "大区副总信息",
        },
        {
          prop: "area_manage_info",
          label: "大区总经理信息",
        },
        {
          prop: "recommender_status",
          label: "状态",
        },
      ],
      checked: false,
      staffSelection: [],
    };
  },
  filters: {
    stateText(val) {
      switch (val) {
        case 0:
          return "离职";
        case 1:
          return "在职";
        default:
          return val;
      }
    },
    text_format(val) {
      if (val == "" || !val) {
        return "-";
      } else {
        return val;
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    //获取列表
    getList() {
      this.tableLoading = true;
      let params = Object.assign(this.queryCondition, this.pagination);
      staff.getStaffList(params).then((res) => {
        let { list, total } = res.data;
        this.totalNum = total;
        this.staffListTable = list;
        this.tableLoading = false;
      });
    },
    searchBtn() {
      this.pagination.page = 1;
      this.getList();
    },
    resetBtn() {
      for (let key in this.queryCondition) {
        if (this.queryCondition[key]) {
          this.queryCondition[key] = null;
        }
      }
    },
    addEmployeeBtn() {
      this.$router.push({
        path: "/home/staff/employeeEditor",
        query: {
          is_add: "1",
        },
      });
    },
    indicatorsBtn() {
      this.isImport = !this.isImport;
    },
    referrerEdit(code) {
      this.$router.push({
        path: "/home/activity/referrerDesc",
        query: {
          recommender_code: code,
        },
      });
    },
    editEmployee(row) {
      let {
        recommender_name,
        recommender_code,
        district_code,
        district_name,
        district_phone,
        area_deputy_code,
        area_deputy_name,
        area_deputy_phone,
        area_code,
        area_name,
        area_phone,
      } = row;
      this.$router.push({
        path: "/home/staff/employeeEditor",
        query: {
          is_add: "0",
          phone: row.phone,
          recommender_name,
          recommender_code,
          district_manager: district_code,
          district_manager_name: district_name,
          district_manager_phone: district_phone,
          area_deputy_manager: area_deputy_code,
          area_deputy_manager_name: area_deputy_name,
          area_deputy_manager_phone: area_deputy_phone,
          area_manager: area_code,
          area_manager_name: area_name,
          area_manager_phone: area_phone,
        },
      });
    },
    searchList() {
      this.getList();
    },
    setStatus(params) {
      staff.setStaffStatus(params).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success("修改成功");
          this.getList();
        }
      });
    },
    startOrEnd(row) {
      let params = {
        recommender_code: row.recommender_code,
        recommender_status: row.recommender_status == 1 ? 0 : 1,
      };

      this.setStatus(params);
    },
    startBtn() {
      let selectData = this.staffSelection.filter((item, index) => {
        return item.recommender_status != 1;
      });
      if (!selectData.length) return;
      let codeArr = [];
      for (let item of selectData) {
        codeArr.push(item.recommender_code);
      }
      let params = {
        recommender_code: codeArr.join(","),
        recommender_status: 1,
      };
      console.log(params);
      this.setStatus(params);
    },
    endBtn() {
      let selectData = this.staffSelection.filter((item, index) => {
        return item.recommender_status != 0;
      });
      if (!selectData.length) return;
      let codeArr = [];
      for (let item of selectData) {
        codeArr.push(item.recommender_code);
      }
      let params = {
        recommender_code: codeArr.join(","),
        recommender_status: 0,
      };
      this.setStatus(params);
    },
    staffListCheckbox() {
      if (this.checked) {
        this.$refs.staffListTableRef.toggleAllSelection();
      } else {
        this.$refs.staffListTableRef.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.staffSelection = val;
      this.checked = val.length === this.pagination.pageNumber;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  position: relative;
}
.el-table__expand-icon--expanded {
  display: none;
}
.el-table .expanded {
  background-color: #f9f8ee;
}
.filterBox {
  line-height: 32px;
  height: 32px;
  margin-bottom: 20px;
  .box {
    line-height: 32px;
    height: 32px;
    margin-right: 20px;
    .label {
      margin-right: 10px;
    }
  }
  .search-button {
    background-color: #eceff2;
    color: #747981;
  }
}
.staff-list {
  .between {
    justify-content: space-between;
    .searchbox {
      width: 100%;
      justify-content: space-between;
    }
  }
  .footer-box {
    .batch-editor {
      display: flex;
      padding: 10px 0;
      align-items: center;
      .checkbox {
        width: 54px;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    ::v-deep .pagination-container {
      padding-top: 16px;
      .el-pagination {
        margin: 0 !important;
      }
    }
  }
}
.staff-list-table {
  border: solid 1px #c9cbd6;
  .recommender-status {
    display: flex;
    align-items: center;
    i {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin-right: 4px;
    }
  }
}
</style>
<style lang="scss">
.el-image > img {
  height: 100px;
  width: auto;
  display: block;
}
.el-image-viewer__close {
  i {
    color: #ffffff;
  }
}
</style>


